import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { useLocation, useNavigate, useRoutes } from 'react-router-dom'
import { ApiList } from '../../Api/ApiList';
import { fetch_data_from_api_from_query } from '../../Api/APICalls';
import { useQuery } from '@tanstack/react-query';
import NoProduct from '../../Component/NoProduct/NoProduct';
import InvestorPDFCard from '../../Component/Inventor/investor-pdf-card/investor-pdf-card';
import Loader from '../../Component/Loader';
import "./InvestorModulePage.css";
import { get_property_settings } from '../../Component/Helper';


const dummy_data = [
    {
    "id": "2",
    "cat_id": "4",
    "document_name": "test@123",
    "file_name": "http://cdn.jfone.jewelflow.pro/tepl/investor_documents/9930-fv6cLR0LHBzh.png",
    "visible": "1",
    "position": "5"
    },
    {
    "id": "3",
    "cat_id": "4",
    "document_name": "agreement",
    "file_name": "http://cdn.jfone.jewelflow.pro/tepl/investor_documents/3404-sample-1.pdf",
    "visible": "1",
    "position": "10"
    },
    {
    "id": "4",
    "cat_id": "4",
    "document_name": "Ag2",
    "file_name": "http://cdn.jfone.jewelflow.pro/tepl/investor_documents/2018-sample-1.pdf",
    "visible": "1",
    "position": "12"
    }
    ]

export default function InvestorModulePage() {
  const location = useLocation()
  const selected_module = location?.state?.selected_module;
  const titles = location?.state?.titles;
  let show_investor_module_frontend = get_property_settings("show_investor_module_frontend")
  show_investor_module_frontend = show_investor_module_frontend === "Yes"  
  const navigate = useNavigate()
 const pdf_list_query = useQuery({
      queryKey: [ApiList.Investor_get_document, selected_module?.id],
      queryFn: () =>
        fetch_data_from_api_from_query(
          ApiList.Investor_get_document,
          ApiList.Investor_get_document,
          { cat_id: selected_module?.id }
        ),
       enabled: !!selected_module?.id && show_investor_module_frontend,
    });

    
   const header = useMemo(() => {
        return [...new Set([...titles, selected_module.title])].join(" > ");
   }, [
    titles
   ])

   useEffect(() => {
    if(show_investor_module_frontend) return
    navigate("/")
   }, [])
   
   if(!show_investor_module_frontend) return null
   if(pdf_list_query.isLoading) return <Loader isLoading={true}/>
  //(<NoProduct errMsg={"No data found"} hideHomeBtn={true}  hideCartImg={true}/>)
  //(<InvestorPDFCard pdf_data={dummy_data}/>)
  return (
    <section className='investor-module-page'>
            <div className='investor-module-page-header'>
                <h2>{header}</h2>
                
            </div>
            <div className='investor-page-body'>

            {
                !!pdf_list_query.data && Array.isArray(pdf_list_query.data) && !!pdf_list_query.data.length ? (
                            <InvestorPDFCard pdf_data={pdf_list_query.data}/>
                        ): (<NoProduct errMsg={"No data found"} hideHomeBtn={true}  hideCartImg={true}/>)
            }
            </div>

       
    </section>
  )
}
